import jwt from '../../http/requests/auth/jwt/index.js'


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import axios from 'axios'

const apiUrl = 'https://users.evolugy.com/v1/';
const cloudFunctionUrl = 'https://us-central1-evolugy2020.cloudfunctions.net/getToken';

export default {
    loginAttempt({ dispatch }, payload) {

        // New payload for login action
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            closeAnimation: payload.closeAnimation
        }

        // If remember_me is enabled change firebase Persistence
        if (!payload.checkbox_remember_me) {

            // Change firebase Persistence
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

            // If success try to login
            .then(function() {
                dispatch('login', newPayload)
            })

            // If error notify
            .catch(function(err) {

                // Close animation if passed as payload
                if (payload.closeAnimation) payload.closeAnimation()

                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        } else {
            // Try to login
            dispatch('login', newPayload)
        }
    },
    login({ commit, state, dispatch }, payload) {

        // If user is already logged in notify and exit
        if (state.isUserLoggedIn()) {
            // Close animation if passed as payload
            if (payload.closeAnimation) payload.closeAnimation()

            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })

            window.location.href = '/dashboard/d';
            return false
        } else {
            sessionStorage.setItem("showBanner", 1);
        }

        // Try to sigin
        firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)

        .then((result) => {

            console.log('user logged in: ');
            console.log(result);
            var evolugyUser = {};

            // setting up OS variables
            dispatch('updateUserOSPlayerId');

            // ---
            const authUserKey = Object.keys(window.sessionStorage)
                .filter(item => item.startsWith('firebase:authUser'))[0];

            const authUser = JSON.parse(sessionStorage.getItem(authUserKey));

            commit('SET_BEARER', authUser.stsTokenManager.accessToken);
            commit('SET_AUTH_TOKEN', authUser.stsTokenManager.accessToken, { root: true });
            sessionStorage.setItem('AT', authUser.stsTokenManager.accessToken);

            setTimeout(() => {
                console.log(authUser)
                const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + authUser.stsTokenManager.accessToken
                    }
                    // Get user info from EVOlUGY
                axios.get(apiUrl + 'me', {
                    headers: headers
                }).then((response) => {
                    commit('UPDATE_USER_INFO', response.data.data.user, { root: true })
                    sessionStorage.setItem("evolugyUser", JSON.stringify(response.data.data.user));
                    console.log(response);

                }, (error) => {

                    console.log(error);

                });
            }, 30);
            // ---

            // Set FLAG username update required for updating username
            let isUsernameUpdateRequired = false

            // if username is provided and updateUsername FLAG is true
            // set local username update FLAG to true
            // try to update username
            if (payload.updateUsername && payload.userDetails.displayName) {

                isUsernameUpdateRequired = true

                dispatch('updateUsername', {
                    user: result.user,
                    username: payload.userDetails.displayName,
                    notify: payload.notify,
                    isReloadRequired: true
                })
            }

            // Close animation if passed as payload
            if (payload.closeAnimation) payload.closeAnimation()

            // if username update is not required
            // just reload the page to get fresh data
            // set new user data in localstorage
            if (!isUsernameUpdateRequired) {
                commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
                commit('UPDATE_USER_INFO', evolugyUser, { root: true })
                setTimeout(() => {
                    router.push(router.currentRoute.query.to || '/')
                }, 500);

            }

        }, (err) => {

            // Close animation if passed as payload
            if (payload.closeAnimation) payload.closeAnimation()

            payload.notify({
                time: 2500,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
    },
    loginWithEvolugy(authObj) {


        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + authObj.stsTokenManager.accessToken
        }

        // Get user info fomr EVOlUGY
        axios.get(apiUrl + 'me', {
            headers: headers
        }).then((response) => {
            console.log(response);
        }, (error) => {

            console.log(error);

        });
    },

    // Google Login
    loginWithGoogle({ commit, state }, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.GoogleAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    // Facebook Login
    loginWithFacebook({ commit, state }, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.FacebookAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    // Twitter Login
    loginWithTwitter({ commit, state }, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.TwitterAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },

    // Github Login
    loginWithGithub({ commit, state }, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
            return false
        }
        const provider = new firebase.auth.GithubAuthProvider()

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/')
                commit('UPDATE_USER_INFO', result.user.providerData[0], { root: true })
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
    },
    registerUser({ dispatch }, payload) {

        // create user using firebase
        firebase.auth().createUserWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
            .then(() => {
                payload.notify({
                    title: 'Account Created',
                    text: 'You are successfully registered!',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    color: 'success'
                })

                const newPayload = {
                    userDetails: payload.userDetails,
                    notify: payload.notify,
                    updateUsername: true
                }
                dispatch('login', newPayload)
            }, (error) => {

                payload.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })

            })
    },
    registerUserEvolugy({ dispatch }, payload) {

        return new Promise((resolve, reject) => {
            axios.post(cloudFunctionUrl, {})
                .then((response) => {
                    console.log(response);
                    let adminToken = response.data.user.stsTokenManager.accessToken;

                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + adminToken
                    }

                    axios.post(apiUrl, payload.userDetails, {
                        headers: headers
                    }).then(() => {
                        payload.notify({
                            title: 'Account Created',
                            text: 'You are successfully registered!',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            color: 'success'
                        });

                        const newPayload = {
                            userDetails: payload.userDetails,
                            notify: payload.notify,
                            updateUsername: true
                        };

                        dispatch('login', newPayload);
                        window.location.href = '/';

                    }, (error) => {

                        payload.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    });
                })
                .catch((error) => { reject(error) });
        })
    },
    sendPasswordRecoveryEmail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            console.log(payload);
            firebase.auth().sendPasswordResetEmail(payload.email).then(function() {
                // Email sent.
                console.log('User Email password sent');
                resolve('User Email password sent');
            }).catch(function(error) {
                console.log('Error sending email');
                reject('Error sending email');
                // An error happened.
            });
        });

    },
    updateUsername({ commit }, payload) {
        payload.user.updateProfile({
            displayName: payload.displayName
        }).then(() => {

            // If username update is success
            // update in localstorage
            const newUserData = Object.assign({}, payload.user.providerData[0])
            newUserData.displayName = payload.displayName
            commit('UPDATE_USER_INFO', newUserData, { root: true })

            // If reload is required to get fresh data after update
            // Reload current page
            if (payload.isReloadRequired) {
                router.push(router.currentRoute.query.to || '/')
            }
        }).catch((err) => {
            payload.notify({
                time: 8800,
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            })
        })
    },
    // JWT
    loginJWT({ commit }, payload) {

        return new Promise((resolve, reject) => {
            jwt.login(payload.userDetails.email, payload.userDetails.password)
                .then(response => {

                    // If there's user data in response
                    if (response.data.userData) {
                        // Navigate User to homepage
                        router.push(router.currentRoute.query.to || '/')

                        // Set accessToken
                        localStorage.setItem('accessToken', response.data.accessToken)

                        // Update user details
                        commit('UPDATE_USER_INFO', response.data.userData, { root: true })

                        // Set bearer token in axios
                        commit('SET_BEARER', response.data.accessToken)

                        resolve(response)
                    } else {
                        reject({ message: 'Wrong Email or Password' })
                    }

                })
                .catch(error => { reject(error) })
        })
    },
    registerUserJWT({ commit }, payload) {

        const { displayName, email, password, confirmPassword } = payload.userDetails

        return new Promise((resolve, reject) => {

            // Check confirm password
            if (password !== confirmPassword) {
                reject({ message: 'Password doesn\'t match. Please try again.' })
            }

            jwt.registerUser(displayName, email, password)
                .then(response => {
                    // Redirect User
                    router.push(router.currentRoute.query.to || '/')

                    // Update data in localStorage
                    localStorage.setItem('accessToken', response.data.accessToken)
                    commit('UPDATE_USER_INFO', response.data.userData, { root: true })

                    resolve(response)
                })
                .catch(error => { reject(error) })
        })
    },
    fetchAccessToken({ commit }) {
        return new Promise((resolve) => {
            firebase.auth().currentUser.getIdToken(true)
                .then((token) => {
                    commit('SET_AUTH_TOKEN', token)
                    commit('SET_BEARER', token);
                    sessionStorage.setItem('AT', token);
                    resolve(token)
                })
                .catch((err) => {
                    console.error('Error refreshing id token', err)
                })
            
        })
    },
    updateUserOSPlayerId({ state, rootState, dispatch }) {

        console.log('isPushNotificationsEnabledVerbose()');
        // OneSignal.setEmail(rootState.AppActiveUser.email);
        Promise.all([
                OneSignal.isPushNotificationsEnabled(),
                OneSignal.getUserId(),
                OneSignal.getEmailId(),
                OneSignal.getRegistrationId(),
                OneSignal.getNotificationPermission(),
                OneSignal.isOptedOut(),
                // OneSignal.context.serviceWorkerManager.getActiveState()
            ])
            .then(([isSubscribed, userId, emailId, registrationId, notificationPermission, optedOut, serviceWorkerActive]) => {
                console.log('Is Completely Subscribed:', isSubscribed);
                console.log('');
                console.log('What is our OneSignal user ID?', userId);
                if (userId === undefined || userId === null) {
                    console.log('cannot update played id - is null');
                } else {
                    dispatch("updateUserEvolugy", { "player_id": userId });
                }


                console.log('Setting email')
                OneSignal.setEmail(rootState.AppActiveUser.email);

                console.log('emailId', emailId);

                console.log('What is our push subscription token?', registrationId);
                console.log('What is the notification permission status?', notificationPermission);
                console.log('Are you manually opted out?', optedOut);
                console.log("Is a service worker registered and active? (should be false on Safari, otherwise should be 'Worker A (Main)')?", serviceWorkerActive);
                console.log('What is the current URL of this page?', location.href);
                console.log("What environment does OneSignal think it's in?", OneSignal.sdkEnvironment.getWindowEnv());
            })
            .catch(e => {
                console.error("Issue determining whether push is enabled:", e);
            });
    },
    updateUserEvolugy({ commit }, payload) {
        const authUserKey = Object.keys(window.sessionStorage)
            .filter(item => item.startsWith('firebase:authUser'))[0];

        const authUser = JSON.parse(sessionStorage.getItem(authUserKey));

        setTimeout(() => {

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authUser.stsTokenManager.accessToken
            }
            var config = {
                method: 'put',
                url: 'https://users.evolugy.com/v1/me',
                headers: headers,
                data: payload
            };
            axios(config)
                .then(function(response) {
                    console.log(JSON.stringify(response.data));
                    OneSignal.setEmail(rootState.AppActiveUser.email);
                })
                .catch(function(error) {
                    console.log(error);
                });
        }, 20);
    }
}